<template>
  <crud-editor
    ref="editor"
    :definition="definition"
    :is-edit="isEdit"
    :auto-generated-id="false"
    :save="saveData"
    :return-to="returnTo"
    :item-type="entity"
    :inject-form-values="injectFormValues"
    :get-layout="layout"
  />
</template>

<script>
import CrudEditor from '@/components/crud/TabbedEditor';
import formMixin from './form-mixin';
import { getCreateLayoutDefinition } from './form.js';

export default {
  components: {
    CrudEditor
  },
  mixins: [formMixin],
  data: () => ({
    isEdit: false,
    layout: getCreateLayoutDefinition
  }),
  methods: {
    saveData(form) {
      const item = this.createItemFromFormData(this, form);
      return this.$store.dispatch(this.entityStore + '/persistItem', item);
    }
  }
};
</script>
